// View "Kanban" — 3 colunas (pendente / em andamento / concluída) com
// drag-and-drop nativo entre colunas pra mudar status.
import axios from 'axios';
import { Card, Typography, Space } from 'antd';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import DataVencimento from './DataVencimento';
import { STATUS_LABEL, PRIORIDADE_LABEL } from './types';
import type { Atividade } from './types';

const { Text } = Typography;

interface Props {
  atividades: Atividade[];
  loading: boolean;
  onEditar: (a: Atividade) => void;
  onMudou: () => void;
}

export default function KanbanAtividades({ atividades, loading, onEditar, onMudou }: Props) {
  const colunas: { id: Atividade['status']; label: string }[] = [
    { id: 'pendente',     label: 'Pendentes' },
    { id: 'em_andamento', label: 'Em andamento' },
    { id: 'concluida',    label: 'Concluídas' },
  ];
  async function mover(a: Atividade, novoStatus: Atividade['status']) {
    const token = await getToken();
    await axios.post(`${API_URL}/atividades`,
      { action: 'update', id: a.id, status: novoStatus },
      { headers: { Authorization: token } });
    onMudou();
  }
  if (loading) return <Card loading />;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
      {colunas.map(col => {
        const lista = atividades.filter(a => a.status === col.id);
        const info = STATUS_LABEL[col.id];
        return (
          <div key={col.id}
            onDragOver={e => e.preventDefault()}
            onDrop={async (e) => {
              e.preventDefault();
              const id = e.dataTransfer.getData('text/atividade-id');
              const a = atividades.find(x => x.id === id);
              if (a && a.status !== col.id) await mover(a, col.id);
            }}>
            <Card size="small" style={{ minHeight: 300 }}
              title={
                <Text strong style={{ color: info.cor, textTransform: 'uppercase', letterSpacing: 1, fontSize: 11 }}>
                  {col.label} ({lista.length})
                </Text>
              }
              styles={{ header: { borderBottom: `2px solid ${info.cor}` } }}
            >
              <Space direction="vertical" size={6} style={{ width: '100%' }}>
                {lista.map(a => (
                  <Card key={a.id} size="small" hoverable
                    draggable
                    onDragStart={e => e.dataTransfer.setData('text/atividade-id', a.id)}
                    onClick={() => onEditar(a)}
                    style={{ borderLeft: `3px solid ${PRIORIDADE_LABEL[a.prioridade]?.cor || '#888'}` }}
                    bodyStyle={{ padding: 8 }}>
                    <Text strong style={{ fontSize: 12 }}>{a.titulo}</Text>
                    {a.data_vencimento && (
                      <div style={{ marginTop: 4 }}>
                        <DataVencimento iso={a.data_vencimento} status={a.status} />
                      </div>
                    )}
                    <div>
                      <Text type="secondary" style={{ fontSize: 10 }}>
                        {a.atribuicoes.map(x => x.email).join(', ')}
                      </Text>
                    </div>
                    {a.origem_label && (
                      <div>
                        <Text type="secondary" style={{ fontSize: 9 }}>{a.origem_label}</Text>
                      </div>
                    )}
                  </Card>
                ))}
              </Space>
            </Card>
          </div>
        );
      })}
    </div>
  );
}
